import React, { Fragment } from 'react'
import { StyledIconLinkDiv, StyledLabel } from './fragments'

export const POSITION_LABEL_ICON = {
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
    RIGHT: 'RIGHT',
    LEFT: 'LEFT',
}
export const ContentFinder = (positionLabel) => {
    switch (positionLabel) {
    case POSITION_LABEL_ICON.TOP:
        return IconWithLabelTopContent
    case POSITION_LABEL_ICON.RIGHT:
        return IconWithLabelRightContent
    case POSITION_LABEL_ICON.BOTTOM:
        return IconWithLabelBottomContent
    case POSITION_LABEL_ICON.LEFT:
        return IconWithLabelLeftContent
    default:
        return IconWithLabelBottomContent
    }
}
export const IconWithLabelBottomContent = ({ positionLabel, color, onClick, className, to, iconSize, isActive, fontSize, width, height, backgroundcolor, borderradius, title, iconKey, label }) => {
    return <Fragment>
        <StyledIconLinkDiv
            color={color}
            onClick={onClick}
            className={className}
            to={to}
            iconSize={iconSize}
            selected={isActive}
            width={width}
            height={height}
            backgroundcolor={backgroundcolor}
            borderradius={borderradius}
            positionLabel={positionLabel}
        >
            <i className="material-icons" title={title}>{iconKey ? iconKey : 'perm_identity'}</i>
        </StyledIconLinkDiv>
        {
            label &&
            <StyledLabel fontSize={fontSize}>
                {label}
            </StyledLabel>
        }
    </Fragment>
}

export const IconWithLabelTopContent = ({ positionLabel, color, onClick, className, to, iconSize, isActive, fontSize, width, height, backgroundcolor, borderradius, title, iconKey, label }) => {
    return <Fragment>
        {
            label &&
             <StyledLabel fontSize={fontSize}>
                 {label}
             </StyledLabel>
        }
        <StyledIconLinkDiv
            color={color}
            onClick={onClick}
            className={className}
            to={to}
            iconSize={iconSize}
            selected={isActive}
            width={width}
            height={height}
            backgroundcolor={backgroundcolor}
            borderradius={borderradius}
            positionLabel={positionLabel}
        >
            <i className="material-icons" title={title}>{iconKey ? iconKey : 'perm_identity'}</i>
        </StyledIconLinkDiv>
    </Fragment>
}

export const IconWithLabelRightContent = ({ positionLabel, justifyContent, color, onClick, className, to, iconSize, isActive, fontSize, backgroundcolor, width = '100%', height = 'unset', borderradius = '28px', title, iconKey, label, padding = '25px 18px' }) => {
    return <Fragment>
        <StyledIconLinkDiv
            color={color}
            onClick={onClick}
            className={className}
            to={to}
            iconSize={iconSize}
            selected={isActive}
            backgroundcolor={backgroundcolor}
            positionLabel={positionLabel}
            borderradius={borderradius}
            width={width}
            height={height}
            padding={padding}
            justifyContent={justifyContent}
        >
            <i className="material-icons" title={title}>{iconKey ? iconKey : 'perm_identity'}</i>
            {
                label &&
				<StyledLabel
				    fontSize={fontSize}
				    positionLabel={positionLabel}>
				    {label}
				</StyledLabel>
            }
        </StyledIconLinkDiv>
    </Fragment>
}

export const IconWithLabelLeftContent = ({ positionLabel, justifyContent, color, onClick, className, to, iconSize, isActive, fontSize, backgroundcolor, width = '100%', height = 'unset', borderradius = '28px', title, iconKey, label, padding = '25px 18px' }) => {
    return <Fragment>
        <StyledIconLinkDiv
            color={color}
            onClick={onClick}
            className={className}
            to={to}
            iconSize={iconSize}
            selected={isActive}
            width={width}
            backgroundcolor={backgroundcolor}
            borderradius={borderradius}
            height={height}
            positionLabel={positionLabel}
            padding={padding}
            justifyContent={justifyContent}
        >
            {
                label &&
				<StyledLabel
				    fontSize={fontSize}
				    positionLabel={positionLabel}>
				    {label}
				</StyledLabel>
            }
            <i className="material-icons" title={title}>{iconKey ? iconKey : 'perm_identity'}</i>
        </StyledIconLinkDiv>
    </Fragment>
}